import { IdsInput, SuccessMessageResponse } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function sendFinalContractReminderToStaffs(input: IdsInput) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.sendFinalContractReminderToStaffs.url, null))
    .post<SuccessMessageResponse, IdsInput>(input)
}

export function sendFinalMissingDocumentsReminderToStaffs(input: IdsInput) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.sendFinalMissingDocumentsReminderToStaffs.url, null))
    .post<SuccessMessageResponse, IdsInput>(input)
}
